import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import Navbar from './components/Navbar';
import Welcome from './components/Welcome';
import AboutUs from './components/AboutUs';
import Services from './components/Services';
import ContactUs from './components/ContactUs';
import GetQuote from './components/GetQuote';
import Projects from './components/Projects';
import Clients from './components/Clients';
import Footer from './components/Footer';
import './App.css';
import NewsPromotions from './components/NewsPromotions';

const App = () => {
  return (
    <div>
    
      <Navbar />
      <Routes>
        <Route path="/" element={<Welcome />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/services" element={<Services />} />
        <Route path="/team" element={<Navigate to="/about" replace />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/clients" element={<Clients />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/quote" element={<GetQuote />} />
        <Route path="/news" element={<NewsPromotions />} />
      </Routes>
      <Footer />
   
    </div>
  );
};

export default App;
